import { render, staticRenderFns } from "./ProductIntro.vue?vue&type=template&id=aebc0c24&scoped=true"
import script from "./ProductIntro.vue?vue&type=script&lang=js"
export * from "./ProductIntro.vue?vue&type=script&lang=js"
import style0 from "./ProductIntro.vue?vue&type=style&index=0&id=aebc0c24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aebc0c24",
  null
  
)

export default component.exports